<template>
  <div>
    <div class="uv-card">
      <div class="uv-card-body">
        <h3 class="uv-card-title">Configuración Tipos de Cambio</h3>
      </div>
    </div>
    <v-row class="mt-2">
      <v-col md="12" cols="12">
        <template v-for="(tp, tpIndex) in tiposCambio">
          <v-card v-if="tp" :key="tpIndex">
            <v-card-title> Moneda Principal: {{ tp.Default }} </v-card-title>
            <v-card-text>
              <p>Indique los montos de cambio para una cada unidad indicada:</p>
              <v-form ref="tcForm">
                <template v-for="(cambio, index) in tp.TC">
                  <div :key="index" class="field">
                    <v-text-field :label="'1 ' + index + ' ='" v-model="tp.TC[index]" :rules="rulesTC">
                      <p slot="append" color="green">
                        {{ tp.Default }}
                      </p>
                    </v-text-field>
                  </div>
                </template>
              </v-form>
              <v-btn color="success" @click="saveData(tp, tpIndex)">
                Guardar
              </v-btn>
            </v-card-text>
          </v-card>
        </template>
      </v-col>
      <v-col md="12" cols="12">
        <v-card>
          <v-card-title>
            Historico de tipos de cambio
          </v-card-title>
          <v-card-text>
            <v-data-table :headers="headers" :items="listado">
              <template v-slot:item.FechaCreacion="{ item }">
                {{ formatDate(item.FechaCreacion) }}
              </template>
              <template v-slot:item.TC="{ item }">
                <ul>
                  <template v-for="(tc, indexTc) in item.TC">
                    <li color="primary" :key="indexTc">
                      1 {{ indexTc }} = {{ tc }} {{ item.Default }}
                    </li>
                  </template>
                </ul>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
.cc-log {
  display: none !important;
}
</style>

<script>
import moment from "moment";
import { V } from "../../helpers/ValidationRules";
export default {
  name: "configTiposCambios",
  components: {},
  data() {
    return {
      //tiposCambio:[],
      headers: [

        {
          text: "Fecha",
          value: "FechaCreacion",
        },
        {
          text: "Moneda Default",
          value: "Default"
        },
        {
          text: "Tipos Cambio",
          value: "TC"
        },
      ],
      listadoTiposCambio: [],
      systemConf: {
        round: false,
        requestNum: false,
        iva: "",
        mxnDollar: "",
        AlertasDeRetiro: false,
        LimiteAlertaRetiro: 0,
      },
      rulesTC: [
        V.required('El tipo de cambio es requerido'),
        V.numeric('Debe ser un número válido'),
        V.positiveNumber('El tipo de cambio debe ser mayor a 0'),
      ],
    };
  },
  computed: {
    listado() {
      return this.listadoTiposCambio || [];
    },
    departments() {
      return this.$store.getters.getPDVDepartamentos;
    },
    tiposCambio() {
      return [this.$store.getters.getTiposCambios[0]];
    },
  },
  methods: {
    formatDate(timestamp) {
      let d = new Date(timestamp);
      //
      //let Creacion =   d.getDate()  + "-" + (d.getMonth()+1) + "-" + d.getFullYear() + " " + d.getHours() + ":" + d.getMinutes();
      return new moment(d).format("DD-MM-YYYY HH:mm");
    },
    async getAllTiposCambios() {
      let data = await this.$store.getters.getFirebaseApp.firestore.queryBuilder(
        "PDV_TipoCambio",
        [
          this.$store.getters.getFirebaseApp.firestore.where(
            "Tenant",
            "==",
            this.$store.getters.getFirebaseApp.tenant
          ),
          this.$store.getters.getFirebaseApp.firestore.orderBy(
            "FechaCreacion",
            "desc"
          ),
        ]
      );

      let informacion = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      informacion.sort((a, b) => {
        const nameA = a.FechaCreacion;
        const nameB = b.FechaCreacion;
        if (nameA > nameB) {
          return -1;
        }
        if (nameA < nameB) {
          return 1;
        }
        return 0;
      });

      this.listadoTiposCambio = informacion;
    },
    saveData(data, index) {
      const form = Array.isArray(this.$refs.tcForm) ? this.$refs.tcForm[index] : this.$refs.tcForm;
      if (form && !form.validate()) {
        return;
      }
      let tcData = Object.entries(data.TC);
      this.$pgsHelper.log(tcData);
      tcData.forEach((ele, index) => {
        data.TC[ele[0]] = parseFloat(ele[1]);
      });
      this.$swal({
        title: "¿Deseas modificar la configuración de tipos de cambio?",
        text: " Los cambios se aplicaran en todo el sistema ",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("GBL-TipoCambio-modificarTipoCambio", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.writeLog({
              Evento: "TIPO_CAMBIO_EDIT",
              Mensaje: "Configuración de tipo de cambio actualizada",
              reference: { id: data.id || "GLOBAL", tp: "GBL-TipoCambio", al: "TIPO DE CAMBIO" },
              data: data
            });
            this.$swal({
              title: "Guardado",
              text: "La configuración se guardo correctamente ",
              icon: "success",
            });
            this.getAllTiposCambios();
          } else {
            this.$swal(
              "Error Aplicando Configuración",
              result.value.data.error,
              "error"
            );
          }
        }
      });
      //ProShop-Monedas-ModificarTipoCambio
    },
  },
  beforeMount: function () { },
  mounted: function () {
    //this.getData();
    this.getAllTiposCambios();
  },
};
</script>
